module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.isImageModalActive = true
      }
    }
  }, [_vm._v("\n            Launch image modal\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary is-medium",
    on: {
      "click": function($event) {
        _vm.isCardModalActive = true
      }
    }
  }, [_vm._v("\n            Launch card modal (keep scroll)\n        ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isImageModalActive
    },
    on: {
      "update:active": function($event) {
        _vm.isImageModalActive = $event
      }
    }
  }, [_c('p', {
    staticClass: "image is-4by3"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/placeholder-1280x960.png"
    }
  })])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.isCardModalActive,
      "width": 640,
      "scroll": "keep"
    },
    on: {
      "update:active": function($event) {
        _vm.isCardModalActive = $event
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image is-4by3"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/placeholder-1280x960.png",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-48x48"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/placeholder-1280x960.png",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("John Smith")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("@johnsmith")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n                        Phasellus nec iaculis mauris. "), _c('a', [_vm._v("@bulmaio")]), _vm._v(".\n                        "), _c('a', [_vm._v("#css")]), _vm._v(" "), _c('a', [_vm._v("#responsive")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("11:09 PM - 1 Jan 2016")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4f7bcb2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/modal/examples/ExSimple.vue
// module id = 1121
// module chunks = 26 116